var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeHigh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "volume-high"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.66699 8.3333V11.6666C1.66699 13.3333 2.50033 14.1666 4.16699 14.1666H5.35866C5.66699 14.1666 5.97533 14.2583 6.24199 14.4166L8.67533 15.9416C10.7753 17.2583 12.5003 16.3 12.5003 13.825V6.17499C12.5003 3.69165 10.7753 2.74165 8.67533 4.05832L6.24199 5.58332C5.97533 5.74165 5.66699 5.83332 5.35866 5.83332H4.16699C2.50033 5.83332 1.66699 6.66665 1.66699 8.3333Z",
    stroke: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 6.66663C16.4833 8.64163 16.4833 11.3583 15 13.3333",
    stroke: "#0F172A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5254 4.58337C18.9337 7.79171 18.9337 12.2084 16.5254 15.4167",
    stroke: "#0F172A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeHigh);
export default __webpack_public_path__ + "static/media/volume-high.3fcd72295d660a90beac81cbe9c3cc13.svg";
export { ForwardRef as ReactComponent };